import { render, staticRenderFns } from "./ArtistsSearch.vue?vue&type=template&id=7265404a&"
import script from "./ArtistsSearch.vue?vue&type=script&lang=js&"
export * from "./ArtistsSearch.vue?vue&type=script&lang=js&"
import style0 from "./ArtistsSearch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports